import Api from "../apiService";

class orderPointsApi {
  index(companyId, orderId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/orders/${orderId}/order_points`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, orderId, pointId) {
    return Api.getRequest(
      `companies/${companyId}/orders/${orderId}/order_points/${pointId}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, orderId, data) {
    return Api.postRequest(
      `companies/${companyId}/orders/${orderId}/order_points`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, orderId, pointId, data) {
    return Api.patchRequest(
      `companies/${companyId}/orders/${orderId}/order_points/${pointId}`,
      data,
      Api.authHeaders()
    );
  }

  delete(companyId, orderId, pointId) {
    return Api.deleteRequest(
      `companies/${companyId}/orders/${orderId}/order_points/${pointId}`,
      Api.authHeaders()
    );
  }

  reorder(companyId, orderId, data) {
    return Api.patchRequest(
      `companies/${companyId}/orders/${orderId}/order_points/reorder`,
      data,
      Api.authHeaders()
    );
  }
}

export default new orderPointsApi();
